module.exports = __webpack_public_path__ + "media/images/icons/country_flags/pk-e742c27f73142b4cff7fc3e547863a58.svg";